<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'REKAPITULASI LAPORAN' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <LeftMenuRl active="rl" />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-9">
                  <PageContentHeader
                    :data="dataRl"
                    :fromUrl="fromUrl || ''"
                    :fromTab="$route.query.fromTab || ''"
                  />
                </div>
                <div class="col-md-3">
                  <download-excel
                    class="btn btn-default btn-primary btn-block"
                    :data="combinedData"
                    worksheet="RL-1"
                    name="rekapitulasi_laporan_1"
                  >
                    Download Excel
                  </download-excel>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-body">
                  <h4>Formulir RL 1.1 Dasar Rumah Sakit</h4>
                  <table>
                    <tbody>
                      <tr
                        v-for="item in rl11"
                        v-bind:key="item.key + Math.random(1023) * 1000"
                      >
                        <td
                          :class="
                            `pb-2 ` + (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          <strong
                            :style="
                              item.content === ''
                                ? 'font-size:14px;color:#097ceb'
                                : ''
                            "
                            >{{ item.title }}</strong
                          >
                        </td>
                        <td
                          :class="
                            `pl-4 pr-2 pb-2 ` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content !== "" ? " : " : "" }}
                        </td>
                        <td
                          :class="
                            `pr-1 pb-2` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h4>Formulir RL 1.2 Indikator Pelayanan Rumah Sakit</h4>
                  <table>
                    <tbody>
                      <tr
                        v-for="item in rl12"
                        v-bind:key="item.key + Math.random(1023) * 1000"
                      >
                        <td
                          :class="
                            `pb-2 ` + (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          <strong
                            :style="
                              item.content === ''
                                ? 'font-size:14px;color:#097ceb'
                                : ''
                            "
                            >{{ item.title }}</strong
                          >
                        </td>
                        <td
                          :class="
                            `pl-4 pr-2 pb-2 ` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content !== "" ? " : " : "" }}
                        </td>
                        <td
                          :class="
                            `pr-1 pb-2` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h4>Formulir RL 1.3 Fasilitas Tempat Tidur</h4>
                  <table>
                    <tbody>
                      <tr
                        v-for="item in rl13"
                        v-bind:key="item.key + Math.random(1023) * 1000"
                      >
                        <td
                          :class="
                            `pb-2 ` + (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          <strong
                            :style="
                              item.content === ''
                                ? 'font-size:14px;color:#097ceb'
                                : ''
                            "
                            >{{ item.title }}</strong
                          >
                        </td>
                        <td
                          :class="
                            `pl-4 pr-2 pb-2 ` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content !== "" ? " : " : "" }}
                        </td>
                        <td
                          :class="
                            `pr-1 pb-2` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import LeftMenuRl from "@/components/LeftMenuRl.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  dataRl,
  tabs,
  filtersRujukan,
  sort,
  upperTabs,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRujukan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    LeftMenuRl,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded: true,
      data: data,
      dataRl: dataRl,
      upperTabs: upperTabs,
      LeftMenuRl: LeftMenuRl,
      rl11: [],
      rl12: [],
      rl13: [],
      combinedData: [],
    };
  },
  methods: {
    combineData: async function() {
      this.combinedData = [
        {
          Judul: "Formulir RL 1",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        {
          Judul: "Formulir RL 1.1 Dasar Rumah Sakit",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        ...this.rl11.map(function(item) {
          return { Judul: item.title, Data: String(item.content) };
        }),
        {
          Judul: "",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        {
          Judul: "Formulir RL 1.2 Indikator Pelayanan Rumah Sakit",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        ...this.rl12.map(function(item) {
          return { Judul: item.title, Data: String(item.content) };
        }),
        {
          Judul: "",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        {
          Judul: "Formulir RL 1.3 Fasilitas Tempat Tidur",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        ...this.rl13.map(function(item) {
          return { Judul: item.title, Data: String(item.content) };
        }),
      ];
    },
    displayData: async function(rl, endpoint) {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(key) {
            let content = "";
            if (typeof result.data[key] !== "object") {
              content = result.data[key];
            }
            rl.push({
              title: key
                .replace(/_/g, " ")
                .split(" ")
                .map((word) => word[0].toUpperCase() + word.slice(1))
                .join(" "),
              key: key,
              content: content,
            });
            if (typeof result.data[key] === "object") {
              Object.keys(result.data[key]).forEach(function(innerKey) {
                let innerContent = "";
                if (typeof result.data[key][innerKey] !== "object") {
                  innerContent = result.data[key][innerKey];
                }
                rl.push({
                  title: innerKey
                    .replace(/_/g, " ")
                    .split(" ")
                    .map((word) => word[0].toUpperCase() + word.slice(1))
                    .join(" "),
                  key: innerKey,
                  content: innerContent,
                });
                if (typeof result.data[key][innerKey] === "object") {
                  Object.keys(result.data[key][innerKey]).forEach(function(
                    innerInnerKey
                  ) {
                    let innerInnerContent = "";
                    if (
                      typeof result.data[key][innerKey][innerInnerKey] !==
                      "object"
                    ) {
                      innerInnerContent =
                        result.data[key][innerKey][innerInnerKey];
                    }
                    rl.push({
                      title: innerInnerKey
                        .replace(/_/g, " ")
                        .split(" ")
                        .map((word) => word[0].toUpperCase() + word.slice(1))
                        .join(" "),
                      key: innerInnerKey,
                      content: innerInnerContent,
                    });
                  });
                }
              });
            }
          });
          ////console.log(self.formSet);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.displayData(this.rl11, "rekapitulasi_laporan_1_1");
    await this.displayData(this.rl12, "rekapitulasi_laporan_1_2");
    await this.displayData(this.rl13, "rekapitulasi_laporan_1_3");
    await this.combineData();
  },
};
</script>
